import axios from "axios";
import Cookies from "universal-cookie";
import { backendUrl } from "../utils/url";

const cookies = new Cookies();

const api = axios.create({
  baseURL: backendUrl,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${cookies.get("jwt-auth")}`,
  },
});

export const createNewNotice = async (data) => {
  try {
    const res = await api.post("/notice/create", data);
    return res;
  } catch (err) {
    return err.response;
  }
};

export const getAllNotices = async () => {
  try {
    const res = await api.get("/notice/all");
    return res;
  } catch (err) {
    return err.response;
  }
};

export const deleteNotice = async (id) => {
  try {
    const res = await api.delete("/notice/delete/" + id);
    return res;
  } catch (err) {
    return err.response;
  }
};

export const getNoticeReaders = async (id) => {
  try {
    const res = await api.get("/notice/readers/" + id);
    return res;
  } catch (err) {
    return err.response;
  }
};
